




































































































































import Vue from 'vue'
import { convert } from './convert'

export default Vue.extend({
  name: 'Converter',

  data: () => ({
    snackbarCopy: false,
    snackbarCopyNote: 'Copied to clipboard!',
    snackbarNoInput: false,

    originalUrl: '',
    webvpnUrl: '',

    commonResources: [
      // {
      //   name: '本科生教务系统',
      //   url: 'jwms.bit.edu.cn'
      // },
      // {
      //   name: '学生评教系统',
      //   url: 'pj.bit.edu.cn'
      // },
      // {
      //   name: '软件正版化平台',
      //   url: 'ca.bit.edu.cn'
      // },
      {
        name: '中国知网',
        url: 'www.cnki.net'
      }
    ]
  }),

  methods: {
    convert (): void {
      const originalUrl = this.originalUrl
      if (originalUrl === '') {
        this.snackbarNoInput = !this.snackbarNoInput
      } else {
        this.webvpnUrl = this.encryptUrl(originalUrl)
      }
    },

    encryptUrl (url: string): string {
      return `https://d.buaa.edu.cn${convert(url)}`
    },

    clearInputUrl (): void {
      this.originalUrl = ''
    },

    copy (value: string): void {
      if (this.webvpnUrl === '') {
        value = 'https://d.buaa.edu.cn'
        this.snackbarCopyNote = 'Default WEBVPN URL copied!'
      }
      console.log('Copied value:', value)
      // eslint-disable-next-line
      ;(this as any).$clipboard(value)
      this.snackbarCopy = !this.snackbarCopy
    }
  }
})
